<template>
  <div class="item-cover-options">
    <div class="form-group">
      <Label for="itemTitleNameSize" text="Tamanho do nome" />
      <select
        class="custom-select"
        id="itemTitleNameSize"
        v-model="itemTitleNameSize"
      >
        <option
          v-for="(size, index) in titleNameSizes"
          :key="index"
          :value="size"
        >
          {{ size.name }}
        </option>
      </select>
    </div>
    <div class="form-group">
      <Label for="background" text="Imagem" />
      <div class="custom-file">
        <input
          type="file"
          class="custom-file-input"
          id="backgroundFile"
          @change="changeBackground($event.target)"
          :multiple="false"
          lang="pt-br"
          accept=".jpg,.jpeg,.png,.gif"
        />
        <label class="custom-file-label text-truncate" for="backgroundFile">
          <small class="text-muted">
            {{ item.file ? item.file.name : 'Selecione uma imagem aqui' }}
          </small>
        </label>
      </div>
    </div>
    <div class="form-group">
      <Label text="Enquadramento" />
      <ImageFraming v-model="itemBackgroundSize" />
    </div>
    <div class="form-group">
      <Label text="Posicionamento" />
      <div class="row" id="background-axis">
        <div class="col">
          <small class="text-center">Horizontal</small>
          <input
            class="custom-range"
            type="range"
            min="0"
            max="100"
            step="1"
            id="background-horizontal-axis"
            v-model="itemBackgroundPositionX"
          />
        </div>
        <div class="col">
          <small class="text-center">Vertical</small>
          <input
            class="custom-range"
            type="range"
            min="0"
            max="100"
            step="1"
            id="background-vertical-axis"
            v-model="itemBackgroundPositionY"
          />
        </div>
      </div>
    </div>
    <div class="form-group">
      <Label for="itemBackgroundColor" text="Cor de fundo" />
      <ChromeColorPicker
        class="w-100"
        :value="itemBackgroundColor"
        @input="changeBackgroundColor"
      />
    </div>
  </div>
</template>

<script>
  import { mapActions, mapState } from 'vuex'
  import { mapFields } from 'vuex-map-fields'
  import { Chrome as ChromeColorPicker } from 'vue-color'

  import ImageFraming from './ImageFraming.vue'
  import Label from './Label.vue'

  export default {
    name: 'ItemCoverOptions',
    components: {
      ImageFraming,
      Label,
      ChromeColorPicker
    },
    computed: {
      ...mapState([
        'item',
        'rarities',
        'titleNameSizes',
        'types',
      ]),
      ...mapFields({
        itemBackgroundColor: 'item.backgroundColor',
        itemBackgroundPositionX: 'item.backgroundPositionX',
        itemBackgroundPositionY: 'item.backgroundPositionY',
        itemBackgroundSize: 'item.backgroundSize',
        itemTitleNameSize: 'item.titleNameSize',
      })
    },
    methods: {
      ...mapActions([ 'setItemFile' ]),
      changeBackground({ files }) {
        this.setItemFile(files[0]);
      },
      changeBackgroundColor({ hex8 }) {
        if (window.BCTimeoutId) clearTimeout(window.BCTimeoutId)

        window.BCTimeoutId = setTimeout(() => {
          this.itemBackgroundColor = hex8;
        }, 300, false);
      }
    }
  }
</script>

<style lang="scss" scoped>
  .custom-file-label::after {
    content: "\f115" !important;
    font-family: "FontAwesome";
  }

  /deep/ .vc-chrome {
    border: 1px solid #eeeeee;
    box-shadow: none !important;

    .vc-chrome-toggle-btn,
    .vc-editable-input span {
      display: none;
    }
  }
</style>